import { render, staticRenderFns } from "./Inbox.vue?vue&type=template&id=300886b6&scoped=true"
import script from "./Inbox.vue?vue&type=script&lang=js"
export * from "./Inbox.vue?vue&type=script&lang=js"
import style0 from "./Inbox.vue?vue&type=style&index=0&id=300886b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300886b6",
  null
  
)

export default component.exports